// B.A.Savage — Scroll fade-up animations
// Targets any element with class "bas-fade-up"
// Add class="bas-fade-up" to any Dawn section wrapper you want to animate

document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll('.bas-fade-up');

  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  targets.forEach((el) => observer.observe(el));
});